<template>
    <div class="w-100" ref="vid_wrap">
        <lazy-component tag="div" >
            <div v-if="!descrSelected" class="video-responsive" v-html="video_regular"></div>
            <div v-else class="video-responsive" v-html="video_descr"></div>
        </lazy-component>
        <div class="d-flex justify-content-end vid-toggle-wrapper" :class="{'small': is_small}">
            <template v-if="video_descr">
            <button 
                class="btn-reset guide-text2"
                v-on:click="descrSelected = true" 
                :class="{'active': descrSelected}">{{ $t(iKey('ui_labels', 'ui', 'with_desc_audio')) }}</button>
            <button 
                class="btn-reset guide-text2" 
                v-on:click="descrSelected = false" 
                :class="{'active': !descrSelected}">{{ $t(iKey('ui_labels', 'ui', 'without_desc_audio')) }}</button>
            </template>
        </div>
    </div>          
</template>

<script>
export default {
  name: 'VideoEmbed',
  props: [
    'video_regular',
    'video_descr',
    'is_small'
  ],
  data: () => {
      return {
          descrSelected: false
      }
  },
  methods: {
      stop() {
        let ytube = this.$refs.vid_wrap.getElementsByTagName('iframe')
        try {
            ytube[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
        } 
        catch(err) {
            //console.log('stop vid playback error: ', err)
        }
      }
  }
}
</script>

<style scoped>
.guide-text2 {
    font-size: 90%;
}
.vid-toggle-wrapper {
    top: 10px;
    position: relative;
}

.vid-toggle-wrapper .active {
    text-decoration: underline;
}
.vid-toggle-wrapper button {
    transition: color 0.2s;
}
.vid-toggle-wrapper button:hover {
    color: #af231c;
}
</style>

